<template>
  <div class="remoteSelect">
    <el-select
      v-if="!isRelated"
      v-model="values"
      :multiple="multiple"
      filterable
      clearable
      collapse-tags
      reserve-keyword
      remote
      :placeholder="placeholder"
      @change="change"
      :remote-method="remoteMethod"
      :loading="loading"
    >
      <el-option
        v-for="item in list"
        :key="item.value"
        :label="item.label"
        :value="item.value"
      >
      </el-option>
    </el-select>
    <el-select
      v-else
      v-model="values"
      :multiple="multiple"
      filterable
      clearable
      collapse-tags
      reserve-keyword
      remote
      :placeholder="placeholder"
      @change="change"
      :remote-method="remoteMethod"
      :loading="loading"
    >
      <el-option-group v-for="g in list" :key="g.value" :label="g.label">
        <el-option
          v-for="item in g.options"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-option-group>
    </el-select>
  </div>
</template>
<script>
export default {
  props: {
    placeholder: {
      type: String,
      default: "",
    },
    level: {
      type: Number,
      default: 3,
    },
    isRelated: {
      type: Boolean,
      default: false,
    },
    getParentValues: {
      type: Function,
      default: null,
    },
    select: {
      type: Function,
      default: null,
    },
    inputLimit: {
      type: Number,
      default: 3,
    },
    multiple: {
      type: Boolean,
      default: true,
    },
    type: {
      type: Number,
      default: 1,
    },
    city: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      loading: false,
      list: [],
      values: [],
      oldValues: [],
      selectedList: [],
      parentValues: [],
    };
  },
  mounted() {},
  methods: {
    remoteMethod(kw) {
      this.loading = true;
      this.parentValues = [];
      if (this.isRelated) {
        const obj = this.getParentValues();
        if (this.multiple) {
          this.parentValues = obj.domainIds;
        } else {
          this.parentValues = [obj.domainIds];
        }
      }
      if (kw instanceof Array) {
        const item = kw[0];
        let index = -1;
        let options = [];
        for (let i = 0; i < this.selectedList.length; i++) {
          if (
            item.value == this.selectedList[i].value &&
            this.selectedList[i].options.filter(
              (item1) => item1.value.split(",")[0] == item.value
            ).length >= 1
          ) {
            index = i;
            options = this.selectedList[i].options;
            break;
          }
        }
        if (index >= 0) {
          this.selectedList.splice(index, 1);
        }
        if (this.multiple) {
          if (this.selectedList.length > 0) {
            let indexs = [];
            this.values.forEach((v, i) => {
              if (options.filter((item) => item.value == v).length == 1) {
                indexs.push(i);
              }
            });
            indexs.forEach((i) => {
              this.values.splice(i, 1);
            });
          } else {
            this.values = [];
          }
        } else {
          this.values = "";
        }
        this.list = this.selectedList;
        this.loading = false;
        return;
      } else {
        kw = kw != null ? kw.trim() : kw;
      }
      if (
        kw == null ||
        kw.length >= this.inputLimit ||
        this.parentValues.length > 0
      ) {
        this.$http
          .get(this.$apiConfig.get_account_permission_url, {
            params: {
              pageNum: 1,
              pageSize: 100,
              level: this.level,
              type: this.type,
              kw: kw,
              multiple: this.multiple,
              parentIdStr: this.parentValues.join(","),
              city: this.city,
            },
          })
          .then((response) => {
            this.list = [];
            this.loading = false;
            const result = response.data;
            if (result.code == 0) {
              const datas = result.data;
              if (datas.length > 0) {
                if (this.isRelated) {
                  let parentName = null;
                  let parentId = null;
                  let parentIds = [];
                  let options = [];
                  datas.forEach((item, index) => {
                    if (
                      parentIds.filter((id) => id == item.parentId).length == 0
                    ) {
                      if (parentName != null) {
                        this.list.push({
                          label: parentName,
                          options: options,
                          value: parentId,
                        });
                      }
                      options = [];
                      parentName = item.parentName;
                      parentId = item.parentId;
                      parentIds.push(parentId);
                    }
                    options.push({
                      label: item.name,
                      value: item.parentId + "," + item.id,
                    });
                  });
                  if (options.length > 0) {
                    this.list.push({
                      label: parentName,
                      options: options,
                      value: parentId,
                    });
                  }
                } else {
                  datas.forEach((item, index) => {
                    this.list.push({
                      label: item.name,
                      value: item.id,
                    });
                  });
                }
                this.setSelectedList();
              }
            }
          })
          .catch((error) => {
            this.loading = false;
            this.$sentry.captureException(error);
          });
      } else {
        this.list = this.selectedList;
        this.loading = false;
      }
    },
    change(values) {
      if (!this.multiple) {
        values = values.length == 0 ? [] : [values];
      }
      let tempList = [];
      if (values.length < this.oldValues.length) {
        if (this.isRelated) {
          let index = -1;
          let parentIndex = -1;
          for (let i = 0; i < this.selectedList.length; i++) {
            let options = this.selectedList[i].options;
            for (let j = 0; j < options.length; j++) {
              if (values.filter((v) => v == options[j].value).length == 0) {
                index = j;
                parentIndex = i;
                break;
              }
            }
            if (index >= 0) break;
          }
          if (index >= 0) {
            if (this.selectedList[parentIndex].options.length == 1) {
              this.selectedList.splice(parentIndex, 1);
            } else {
              this.selectedList[parentIndex].options.splice(index, 1);
            }
          }
        } else {
          let items = [];
          let index = -1;
          for (let i = 0; this.selectedList.length; i++) {
            let item = this.selectedList[i];
            let arr = values.filter((v) => v == item.value);
            if (arr.length == 0) {
              index = i;
              items.push(item);
              break;
            }
          }
          this.selectedList.splice(index, 1);
          this.select(items);
        }
        this.setSelectedList();
      } else {
        values.forEach((v, i) => {
          if (!this.isRelated) {
            if (
              this.selectedList.filter((item) => item.value == v).length == 0
            ) {
              this.selectedList.push(
                this.list.filter((item) => item.value == v)[0]
              );
            }
            this.select(null);
          } else {
            if (
              this.selectedList.filter(
                (g) => g.options.filter((item) => item.value == v).length == 1
              ).length == 0
            ) {
              let group = this.list.filter(
                (g) => g.options.filter((item) => item.value == v).length == 1
              )[0];
              let item = group.options.filter((item) => item.value == v)[0];
              if (
                this.selectedList.filter((g) => g.value == group.value)
                  .length == 0
              ) {
                this.selectedList.push({
                  label: group.label,
                  options: [item],
                  value: group.value,
                });
              } else {
                for (let z = 0; z < this.selectedList.length; z++) {
                  if (this.selectedList[z].label == group.label) {
                    this.selectedList[z].options.push(item);
                    break;
                  }
                }
              }
            }
          }
        });
      }
      this.oldValues = values;
    },
    setSelectedList() {
      if (this.isRelated) {
        this.selectedList.forEach((groupItem, index) => {
          let options = [];
          let groups = this.list.filter(
            (g) =>
              g.label == groupItem.label &&
              g.options.filter(
                (item1) =>
                  groupItem.options.filter(
                    (item2) => item2.value == item1.value
                  ).length > 0
              ).length > 0
          );
          if (groups.length == 0) {
            this.list.push({
              label: groupItem.label,
              options: groupItem.options,
            });
          }
        });
      } else {
        this.selectedList.forEach((selectItem, index) => {
          if (
            this.list.filter((item) => item.value == selectItem.value).length ==
            0
          ) {
            this.list.push(selectItem);
          }
        });
      }
    },
    getValues() {
      if (this.type == 3) {
        let values = [];
        let selectValues = this.multiple ? this.values : [this.values];
        this.selectedList.forEach((g, i) => {
          g.options.forEach((item, index) => {
            if (selectValues.filter((v) => v == item.value).length == 1) {
              values.push(item.label);
            }
          });
        });
        return this.multiple ? values : values.length > 0 ? values[0] : "";
      }
      return this.values;
    },
  },
};
</script>
<style lang="scss" scoped></style>
